import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import type { InitTotpResponse } from '../../../../../shared/types/routes/auth/mfa';

/**
 * Generate secret, QR code, and backup codes
 */
export default function useInitTotpSetup() {
  return useToastedMutation({
    mutationFn: async () => {
      return post<never, InitTotpResponse>(
        '/api/auth/mfa/totp/init',
        undefined as never,
      );
    },
    errorToastMessage: 'Failed to initiate MFA setup',
  });
}
